<template>
  <div class="deviceManage">
    <ListSearch ref="listSearch" :formSearch="formSearch">
      <template #buttons>
        <el-button type="primary" @click="addItem">设备入库</el-button>
      </template>
      <template #forms>
        <el-form-item label="客户">
          <el-select v-model="formSearch.companyId" @change="$refs.listSearch.search()" placeholder="请选择客户" clearable
            filterable>
            <el-option v-for="(item, index) in companyList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备ID">
          <el-input v-model="formSearch.deviceId" @change="$refs.listSearch.search()" placeholder="请输入设备ID"
            clearable></el-input>
        </el-form-item>
        <div class="buttons">
          <el-button type="primary" @click="$refs.listSearch.search()">查询</el-button>
          <el-button @click="$refs.listSearch.reset()">重置</el-button>
        </div>
      </template>
      <template #list="{ tableData, loading }">
        <el-table :data="tableData" border v-loading="loading">
          <el-table-column align="center" v-for="(item, index) in tableKey" :key="index" :label="item.label"
            :width="item.width">
            <template slot-scope="scope">
              <div v-if="item.myFilter" v-html="item.myFilter(scope.row)"></div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="现场照片" width="110">
            <template slot-scope="scope">
              <div class="my-button" @click="showFile(scope.row)">
                <i class="iconfont iconeye"></i>查看
              </div>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="操作" width="250">
            <template slot-scope="scope">
              <div class="my-button" @click="exportData(scope.row)">
                <i class="el-icon-document"></i>数据
              </div>
              <div class="my-button" @click="editItem(scope.row)">
                <i class="iconfont iconedit"></i>修改
              </div>
              <div class="my-button" @click="recycleDevice(scope.row)" v-if="scope.row.companyId">
                <i class="iconfont iconhuishou"></i>回收
              </div>
              <div class="my-button" @click="allotDevice(scope.row)" v-else>
                <i class="iconfont iconchuku"></i>出库
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </ListSearch>
    <EditDialog :dialogShow.sync="editDialogShow" :formData="editDialogData" :companyList="companyList"
      :versionSet="versionSet" @updateData="$refs.listSearch.updateData()"></EditDialog>
    <AllotDialog :dialogShow.sync="allotDialogShow" @updateData="$refs.listSearch.updateData()"
      :companyList="companyList" :allotDialogData="allotDialogData" />
    <ShowFileDialog :dialogShow.sync="fileDialogShow" :datas="fileDialogData" />
    <el-dialog title="选择起止时间" :visible.sync="exportDialogShow" width="25%" :before-close="handleClose">
      <div style="color: #ff381f; height: 35px">
        为了保证数据能成功导出，时间跨度不要超过24小时
      </div>
      <div class="block">
        <el-date-picker v-model="dateTimeArray" type="datetimerange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="doExport()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListSearch from "@/components/ListSearch/ListSearch";
import AllotDialog from "./components/AllotDialog";
import EditDialog from "./components/EditDialog";
import ShowFileDialog from "./components/ShowFileDialog";
export default {
  data() {
    return {
      editDialogShow: false, // 编辑弹窗是否显示
      editDialogData: null, // 编辑弹窗表单数据
      allotDialogShow: false, // 出库弹窗是否显示
      fileDialogShow: false,
      exportDialogShow: false,
      fileDialogData: {
        files: [],
      }, // 附件弹窗数据
      allotDialogData: {
        deviceId: "",
        deviceType: "",
      }, // 出库弹窗数据
      tableKey: [
        {
          prop: "id",
          label: "设备ID",
          width: 100,
        },
        {
          prop: "name",
          label: "设备名称",
          width: 200,
        },
        {
          prop: "versionName",
          label: "版本"
        },
        {
          prop: "statusName",
          label: "状态",
          width: 100,
        },
        {
          prop: "companyName",
          label: "客户",
        },
        {
          prop: "serviceStart",
          label: "服务开始时间",
          width: 120,
        },
        {
          prop: "mode",
          label: "通讯",
          width: 100,
        },
        {
          prop: "iccid",
          label: "ICCID",
          width: 190,
        },
        {
          prop: "supply",
          label: "4G卡来源",
          width: 100,
        },
        {
          prop: "expiration",
          label: "4G卡到期",
          width: 180,
          myFilter: (row) => {
            if (row.expired) {
              return `<div style='color:#ff0000'>${row.expiration}</div>`;
            } else {
              return `${row.expiration}`;
            }
          },
        },
      ],
      formSearch: {
        companyId: "",
      },
      companyList: [], // 项目列表
      typeList: [], // 设备类型列表
      versionSet: [], // 固件版本
      dateTimeArray: [],
    };
  },
  components: {
    ListSearch,
    EditDialog,
    AllotDialog,
    ShowFileDialog,
  },
  created() {
    this.getCompanyList();
    this.getVersionOption();
    var d = new Date();
    d.setDate(d.getDate() - 1);
    this.dateTimeArray[0] = d;
    this.dateTimeArray[1] = new Date();
  },
  mounted() {
    this.$refs.listSearch.search();
  },
  methods: {
    getList(page, size) {
      return this.$http.get("/device/list/v1", {
        ...this.formSearch,
        page,
        size,
      });
    },
    // 获取项目列表
    getCompanyList() {
      this.$http.get("/company/company-all/v1").then((res) => {
        this.companyList = res;
      });
    },
    // 获取项目列表
    getVersionOption() {
      this.$http.get("/device/version-option/v1").then((res) => {
        this.versionSet = res;
      });
    },
    showFile(item) {
      this.fileDialogData = {
        files: item.imageViewSet || [],
        title: item.name,
      };
      this.fileDialogShow = true;
    },
    // 新建
    addItem() {
      this.editDialogData = null;
      this.editDialogShow = true;
    },
    // 编辑
    editItem(item) {
      this.editDialogData = item;
      this.editDialogData.date = [item.serviceStart, item.serviceEnd];
      let images = item.imageViewSet || [];
      this.editDialogData.imageSet = images.map((item) => {
        return {
          uid: item.id,
          id: item.id,
          url: "/staticfile/" + item.src,
        };
      });
      this.editDialogShow = true;
    },
    // 出库
    allotDevice(item) {
      this.allotDialogData = {
        deviceId: item.id,
        deviceType: item.deviceType,
      };
      this.allotDialogShow = true;
    },
    // 回收
    recycleDevice(item) {
      this.$confirm("确认回收吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.$http
          .put(
            "/device/recycle/v1",
            {
              deviceId: item.id,
            },
            "提交中……",
            "回收成功"
          )
          .then(() => {
            this.$refs.listSearch.updateData();
          });
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    exportData(item) {
      this.exportDialogShow = true;
      this.exportDeviceId = item.id;
    },
    doExport() {
      var start = this.dateTimeArray[0].Format("yyyy-MM-dd hh:mm:ss");
      var end = this.dateTimeArray[1].Format("yyyy-MM-dd hh:mm:ss");
      location.href =
        this.$http.baseUrl +
        `/device/data/v1?deviceId=${this.exportDeviceId}&start=${start}&end=${end}`;
      this.exportDialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  margin-left: 10px;
  cursor: pointer;
}

.el-date-editor--datetimerange.el-input__inner {
  width: 400px;
}
</style>

<style lang="scss">
.deviceManage {
  .el-table .cell {
    white-space: normal;
  }
}

.deviceManage-deviceName {
  white-space: nowrap;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .small-tag {
    background: #ccc;
    color: #fff;
    border-radius: 2px;
    font-size: 14px;
    padding: 0 5px;
    margin: 5px;
  }
}
</style>